import {
  List, Datagrid, TextField, DateField, EmailField, EditButton, Edit, Create, SimpleForm,
  TextInput, SelectInput, PasswordInput, required, email,
} from 'react-admin';
import { Stack, Typography } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';

const ROLES = [
  { id: 'super_admin', name: 'Super admin' },
  { id: 'editor', name: 'Editor' },
];

const UserList = () => (
  <List sort={{ field: 'id', order: 'ASC' }} perPage={25}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <EmailField source="email" />
      <TextField source="name" />
      <TextField source="role" />
      <DateField source="lastLoginAt" label="Last login" showTime />
      <EditButton />
    </Datagrid>
  </List>
);

const UserCreate = () => (
  <Create redirect="list">
    <SimpleForm>
      <Stack spacing={2} sx={{ maxWidth: 520 }}>
        <TextInput source="email" validate={[required(), email()]} fullWidth />
        <TextInput source="name" validate={required()} fullWidth />
        <SelectInput source="role" choices={ROLES} validate={required()} defaultValue="editor" />
        <PasswordInput source="password" validate={required()} fullWidth />
      </Stack>
    </SimpleForm>
  </Create>
);

const UserEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm>
      <Stack spacing={2} sx={{ maxWidth: 520 }}>
        <TextInput source="email" validate={[required(), email()]} fullWidth />
        <TextInput source="name" validate={required()} fullWidth />
        <SelectInput source="role" choices={ROLES} validate={required()} />
        <Typography variant="overline" color="text.secondary">Reset password (optional)</Typography>
        <PasswordInput source="password" helperText="Leave blank to keep the existing password" fullWidth />
      </Stack>
    </SimpleForm>
  </Edit>
);

export default {
  list: UserList,
  edit: UserEdit,
  create: UserCreate,
  icon: PeopleIcon,
  options: { label: 'Admin users' },
  recordRepresentation: 'email',
};
